module.exports = __webpack_public_path__ + "img/date.c960c10c.svg";